var _defs, _rect, _path, _polygon, _rect2, _polygon2, _path2, _path3, _path4, _rect3, _rect4, _circle, _circle2, _path5, _path6, _path7, _path8, _circle3, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#24285b;}.cls-2{fill:#0086f4;}.cls-3{fill:#ececec;}.cls-4{fill:#fff;}.cls-5{fill:#69e0a2;}.cls-6{fill:#f0457d;}.cls-7{fill:#ffd44d;}.cls-8{fill:#db2868;}.cls-9{opacity:0.09;isolation:isolate;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Contact Us") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.36,
    y: 105.22,
    width: 433.51,
    height: 307.54,
    rx: 14.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.16,392.9H484.84a0,0,0,0,1,0,0V402a17.8,17.8,0,0,1-17.8,17.8H33A17.8,17.8,0,0,1,15.16,402V392.9A0,0,0,0,1,15.16,392.9Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "203.38 392.9 209.2 402.85 291.21 402.85 296.63 392.9 203.38 392.9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.77,
    y: 122.91,
    width: 406.98,
    height: 258.98,
    rx: 3.27
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "448.32 382.26 41.33 382.26 41.77 142.26 448.32 142.26 448.32 382.26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.53,132.5a4.12,4.12,0,1,1-4.12-4.12A4.12,4.12,0,0,1,83.53,132.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.55,132.5a4.13,4.13,0,1,1-4.12-4.12A4.13,4.13,0,0,1,58.55,132.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.54,132.5a4.12,4.12,0,1,1-4.12-4.12A4.12,4.12,0,0,1,70.54,132.5Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 191.49,
    y: 294.57,
    width: 119.55,
    height: 24.52,
    rx: 7.35,
    transform: "translate(502.53 613.67) rotate(180)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 247.11,
    y: 95.61,
    width: 8.35,
    height: 42.21,
    transform: "translate(502.57 233.44) rotate(180)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 373.28,
    cy: 239.57,
    r: 24.53,
    transform: "translate(-45.29 92.84) rotate(-13.37)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 125.64,
    cy: 237.95,
    r: 24.53,
    transform: "translate(-49.53 33.69) rotate(-12.78)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.42,128.67s-99.74-1.2-115.53,85.19,68.56,88,92.82,89.64c11,.74,34.53.81,55.3.45,46-.79,78.46-9.69,89.52-52.35A80.52,80.52,0,0,0,371,236.32C373.94,189.57,342.29,126.37,246.42,128.67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.77,260.25l-144.9,2.26a27.51,27.51,0,0,1-27.93-27.07h0A27.51,27.51,0,0,1,173,207.51l144.9-2.26a27.5,27.5,0,0,1,27.93,27.07h0A27.51,27.51,0,0,1,318.77,260.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.94,232.44a8.83,8.83,0,1,1-7-10.36A8.83,8.83,0,0,1,203.94,232.44Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.17,230.82a8.82,8.82,0,1,1-7-10.36A8.84,8.84,0,0,1,305.17,230.82Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 251.29,
    cy: 94.77,
    r: 13.76,
    transform: "translate(6.59 205.44) rotate(-45)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.31,228.37c.66.07.33,3.15,2.26,7.26a18.34,18.34,0,0,0,4.68,6.16,14.18,14.18,0,0,0,17.12,1.56,18.13,18.13,0,0,0,5.72-5.21c2.64-3.69,2.88-6.78,3.54-6.73.25,0,.52.78.52,2.24a13.71,13.71,0,0,1-1.6,6,18.43,18.43,0,0,1-6.2,6.89,16.76,16.76,0,0,1-21.62-2,18.36,18.36,0,0,1-4.84-7.91,13.73,13.73,0,0,1-.5-6.15C228.65,229,229.06,228.32,229.31,228.37Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.11,319.1h80.53a63.17,63.17,0,0,1,63.17,63.17v0a0,0,0,0,1,0,0H145.94a0,0,0,0,1,0,0v0a63.17,63.17,0,0,1,63.17-63.17Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M246.42,128.67a149.93,149.93,0,0,0-34.27,4.64c88,2.22,117.33,62.57,114.51,107.64a80.78,80.78,0,0,1-2.48,15.28c-7.32,28.24-24.05,41.67-47.85,47.77L279,304c46-.79,78.46-9.69,89.52-52.35A80.52,80.52,0,0,0,371,236.32C373.94,189.57,342.29,126.37,246.42,128.67Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M289.64,319.1H209.11a63,63,0,0,0-23.73,4.62h59.91a63.16,63.16,0,0,1,63,58.54h44.54A63.17,63.17,0,0,0,289.64,319.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotFlat);
export default __webpack_public_path__ + "static/media/chatbot-flat.91d87fbfb51323477ed10c9adf30309d.svg";
export { ForwardRef as ReactComponent };